/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { DataTableComponentDisplay } from "cms/components/components/data-table/display";
import { DataTableComponentEditor } from "cms/components/components/data-table/edit";

const DataTableComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <DataTableComponentDisplay />,
        editComponent: <DataTableComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

DataTableComponent.displayName = "DataTableComponent";
export { DataTableComponent };
